import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import {
  constructQueryForPostTerms,
} from 'utils/constructQuery';
import tulkojumi from 'utils/tulkojumi';
import { SiteContainer } from 'core/layout';
import { Heading } from 'elements';
import { Dokumenti } from 'pages';


const withTermsPostQuery = (postType, termsArray, lang, tekstiArray) => {
  const QUERY = gql(
    constructQueryForPostTerms(
      termsArray,
      tekstiArray,
    )
  );

  const queryOptions = {
    options: ({ lang, postId }) => ({
      fetchPolicy: 'cache-first',
      variables: {
        lang: (lang || 'lv'),
        postId: postId,
      }
    }),
    props: props => {
      const { data: {
      loading,
        page,
        teksti,
        variables: { lang },
        ...rest
    }} = props;
      return {
        loading,
        page: Array.isArray(page) && page.length > 0 ? page[0] : page,
        teksti,
        lang,
      }
    }
  }

  const TermsPost = (props) => {
    const {
      loading,
      page,
      lang,
      teksti,
    } = props;

      if (loading) {
        return null;
      }

      // TODO: Kļūdas paziņojums.
      // Kā tam vajadzētu funkcionēt?
      if (!page) {
        return (
          <SiteContainer>
            <Heading>
              {tulkojumi(teksti, 'notikusi_kluda')}
            </Heading>
          </SiteContainer>
        );
      }

      return (
        <Dokumenti
          postType={postType}
          data={{ ...props }}
        />
      );
  }

  return compose(
    graphql(QUERY, queryOptions),
  )(TermsPost);
}

export default withTermsPostQuery;



// WEBPACK FOOTER //
// ./src/utils/withTermsPostQuery.js